import { useTheme } from '@mui/material';
import SelectField, { type SelectFieldProps } from 'components/SelectField';
import { Controller, useFormContext } from 'react-hook-form';

type Props<Value extends string | number, Multiple extends boolean = false> = {
  name: string;
} & SelectFieldProps<Value, Multiple>;

export const RHFSelectField = <Value extends string | number, Multiple extends boolean = false>({
  name,
  options,
  ...other
}: Props<Value, Multiple>) => {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <SelectField
          {...field}
          options={options}
          error={!!error}
          helperText={error?.message}
          helperTextSx={{ color: theme.palette.error.main }}
          {...other}
        />
      )}
    />
  );
};
